import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import getInspectionItemPreviousComments from "../../api/inspections/getInspectionItemPreviousComments";

interface InspectionItemPreviousCommentsParams {
  inspectionId: string | number;
  sectionId: string | number;
  itemId: string | number;
  options?: {
    enabled?: boolean;
  };
}
export default function useInspectionItemPreviousComments({
  inspectionId,
  sectionId,
  itemId,
  options,
}: InspectionItemPreviousCommentsParams) {
  const headers = useNetworkHeaders();
  const queryKey = getInspectionItemPreviousCommentsQueryKey(inspectionId, sectionId, itemId);
  const query = useQuery(
    queryKey,
    getInspectionItemPreviousComments(headers, Number(inspectionId), Number(sectionId), Number(itemId)),
    {
      enabled: options?.enabled === undefined ? true : options.enabled,
    },
  );

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

export function getInspectionItemPreviousCommentsQueryKey(
  inspectionId: string | number,
  sectionId: string | number,
  itemId: string | number,
): QueryKey {
  return ["previous-comments", inspectionId, sectionId, itemId].filter((key) => key);
}
